import { ElementProps } from "../../../types/common";

export const TwitterIcon = (props: ElementProps) => (
  <svg
    width={12}
    height={9}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.034 1.064a4.542 4.542 0 0 1-1.301.356c.473-.283.827-.729.996-1.253a4.53 4.53 0 0 1-1.439.55 2.265 2.265 0 0 0-3.86 2.065A6.432 6.432 0 0 1 .76.415a2.266 2.266 0 0 0 .7 3.025 2.258 2.258 0 0 1-1.024-.283v.027a2.267 2.267 0 0 0 1.817 2.222c-.334.09-.684.104-1.024.04a2.267 2.267 0 0 0 2.117 1.573 4.547 4.547 0 0 1-3.354.938 6.408 6.408 0 0 0 3.472 1.018c4.168 0 6.446-3.452 6.446-6.445 0-.098-.002-.197-.006-.294.443-.32.825-.717 1.13-1.172Z"
      fill="#000"
    />
  </svg>
);
